import { createContext } from "react";

const AuthContext_Dev = createContext({
    url_main:'http://127.0.0.1:8000/'
});
const AuthContext = createContext({
    url_main:'https://vacunacan.dirislimasur.gob.pe/'
});
export default AuthContext;